import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ProductLineCustomObjectTypeEntityModel} from "../product-line-custom-object-type-entity.model";
import {CustomObjectTypeEditPageComponent} from "./custom-object-type-edit-page.component";
import {ProductLineCustomObjectEditPageComponent} from "../../custom-object/custom-object-edit-page/product-line-custom-object-edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-product-line-custom-object-type-edit-page",
    templateUrl: "./custom-object-type-edit-page.component.html",
    providers: [provideEntityModel(ProductLineCustomObjectTypeEntityModel)]
})
export class ProductLineCustomObjectTypeEditPageComponent extends CustomObjectTypeEditPageComponent {
    override CustomObjectEditPageComponent = ProductLineCustomObjectEditPageComponent;
    override fixedType: boolean = true;

    constructor(model: ProductLineCustomObjectTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
